import { CanDeactivateFn } from '@angular/router';
import {RegistroStepperComponent} from 'src/app/pages/account/login/registro-stepper/registro-stepper.component';

export const registroSalidaGuard:
  CanDeactivateFn<RegistroStepperComponent> = component =>
    component.confirmarSalidaRuta();